import { render, staticRenderFns } from "./openvip.vue?vue&type=template&id=5e372c0e&scoped=true&"
import script from "./openvip.vue?vue&type=script&lang=js&"
export * from "./openvip.vue?vue&type=script&lang=js&"
import style0 from "./openvip.vue?vue&type=style&index=0&id=5e372c0e&lang=less&scoped=true&"
import style1 from "./openvip.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e372c0e",
  null
  
)

export default component.exports